/* src/app/layouts/paciente-layout/paciente-layout.component.scss */
/*# sourceMappingURL=paciente-layout.component.css.map */
